import { styles } from "./NavigationGroup.css.ts";

/**
 * Component for rendering a button to show chapter modules.
 *
 * @param {Object} props - The properties for the component.
 * @param {ReactNode} props.children - The content to be rendered inside the button.
 * @param {string} props.state - The state of the button.
 * @param {function} props.onClick - The event handler for the button click event.
 * @returns {ReactNode} The rendered button element.
 */
export const ShowChapterModulesButton = ({ children, state, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={styles.chapterButton({ chapterState: state })}
      disabled={state === "disabled"} //todo: use enum!
    >
      {children}
    </button>
  );
};
